<template>
    <div class="flex flex-col items-center bg-white p-20 box-border justify-center">
        <FeatureUnavailableIcon :color="color.hex" />
        <p class="text-body-3 text-default-9 font-normal">
            Feature unavailable
        </p>
        <p class="text-body-6 font-normal text-black/50 mt-4 text-center">
            This feature is not available for your membership.
        </p>
    </div>
</template>
<script setup>
import FeatureUnavailableIcon from '@/components/icons/FeatureUnavailableIcon.vue';
import {useTheme} from "@/stores/ThemeStore";

const {color} = useTheme();
</script>